import React, { useState } from 'react';
import PropTypes from 'prop-types';

function App(props) {
  const [state, setState] = useState({});
  const { 
    api,
    hexonkenteken,
    hexonmerk,
    hexonmodel,
    hexonuitvoering,
    hexonbrandstof,
    hexonisnieuw,
    hexonlefid,
    hexonisvkv,
    hexonvoertuignummer,
    hexonklantnummer,
    hexonverkoopprijs
  } = props;

  // TODO: CURRENTLY HARDCODED TOKENS
  const token = '0836ce25-d7f8-4df7-a78a-40064964a544';

  // set any field
  const setFieldState = (field, bool) => {
    const newState = { [field]: bool };
    setState({ ...state, ...newState });
  };

  // handle change licenseplate
  const handleChangeLicense = (event) => {
    const { name } = event.target;
    let { value } = event.target;
    const originalValue = value;
    let totalKenteken = '';
    let tmp = value.replace(' ', '').replace('-', '');
    let i = 0;
    while (typeof tmp[i] !== 'undefined') {
      const count1 = (totalKenteken.match(/is/g) || []).length;
      if (typeof tmp[i + 1] !== 'undefined' && !Number.isNaN(Number(tmp[i])) !== !Number.isNaN(Number(tmp[i + 1])) && tmp[i] !== '-' && tmp[i + 1] !== '-' && count1 < 2) {
        totalKenteken += tmp.substr(i, 1);
        totalKenteken += '-';
      } else {
        totalKenteken += tmp.substr(i, 1);
      }
      i += 1;
    }
    const count2 = (totalKenteken.match(/is/g) || []).length;
    if (count2 < 2) {
      let i2 = 0;
      tmp = totalKenteken.split('-');
      while (typeof tmp[i2] !== 'undefined') {
        if (tmp[i2].length === 4) {
          totalKenteken = totalKenteken.replace(tmp[i2], tmp[i2][0] + tmp[i2][1] + '-' + tmp[i2][2] + tmp[i2][3]); // eslint-disable-line prefer-template
        }
        i2 += 1;
      }
    }
    if (totalKenteken.substr(0, 1) === '-') {
      totalKenteken = totalKenteken.substr(1);
    }
    tmp = totalKenteken.split('-');
    if (tmp.length >= 4) {
      totalKenteken = `${tmp[0]}-${tmp[1]}-`;
      i = 2;
      while (typeof tmp[i] !== 'undefined') {
        totalKenteken += tmp[i];
        i += 1;
      }
    }
    if (totalKenteken.toUpperCase() !== originalValue) {
      value = totalKenteken.toUpperCase();
    }
    setFieldState(name, value);
  };

  // handle change
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFieldState(name, value);
  };

  // feedback class
  /*
  const inputFeedback = (field) => {
    if (field === 'kenteken' && state.loading === false) {
      return (state[field] && state[field].length >= 8)
        ? 'is--valid' : 'is--invalid';
    }
    if (field === 'kilometerstand' && (state[field] || state.loading === false)) {
      return (!Number.isNaN(Number(state[field])) && state[field] > 0)
        ? 'is--valid' : 'is--invalid';
    }

    return '';
  };
  */

  // feedback display
  const displayFeedback = (field) => {
    if (field === 'kenteken' && state.loading === false) {
      return (state[field] && state[field].length >= 8)
        ? 'hidden' : 'display-block';
    }
    if (field === 'kilometerstand' && (state[field] || state.loading === false)) {
      return (!Number.isNaN(Number(state[field])) && state[field] > 0)
        ? 'hidden' : 'display-block';
    }

    return 'hidden';
  };

  // submit
  const submit = () => {
    setFieldState('loading', false);
    const { kenteken, kilometerstand } = state;
    if (kenteken && kenteken.length >= 8 && kilometerstand
      && Number(kilometerstand) > 0) {
        
      setFieldState('loading', true);
        
      // Modern browser redirect
      if (window.document.documentMode) {
        window.location = '/inruilen';
      }

      fetch(`${api}/GetVehicleDataPRO`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
          token,
          vehicle: {
            kenteken,
            kilometerstand,
            // CustomerToken: customerToken,
          },
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          const { NieuwPrijs } = data.d.BasisGegevens;
          if (NieuwPrijs > 0) {
            // good car, send to inruilen page/app
            let hexonUrl = '';
            if (hexonkenteken
              && hexonmerk
              && hexonmodel
              && hexonuitvoering
              && hexonbrandstof
              && hexonisnieuw
              && hexonlefid
              && hexonisvkv
              && hexonvoertuignummer
              && hexonklantnummer
              && hexonverkoopprijs
            ) {
              hexonUrl = `&hexonkenteken=${hexonkenteken}&hexonmerk=${hexonmerk}&hexonmodel=${hexonmodel}&hexonuitvoering=${hexonuitvoering}&hexonbrandstof=${hexonbrandstof}&hexonisnieuw=${hexonisnieuw}&hexonlefid=${hexonlefid}&hexonisvkv=${hexonisvkv}&hexonvoertuignummer=${hexonvoertuignummer}&hexonklantnummer=${hexonklantnummer}&hexonverkoopprijs=${hexonverkoopprijs}`;
            }
            window.location = `inruilen?kenteken=${kenteken}&kilometerstand=${kilometerstand}${hexonUrl}`;
          }
          // setFieldState('loading', false);
        }).catch((err) => {
          setFieldState('loading', false);
        });
    } else {
      setFieldState('loading', false);
    }
  };

  const isLoading = () => (
    state.loading
  );

  return (
    <div className="App">
      <div className={`loading ${isLoading() ? 'is--loading' : ''}`}>
        <form className="inruilen-start-form">
          <fieldset className="userform">
            <div id="Form_InruilenForm_Kenteken_Holder" className="field text kentekenField sign--half">
              <label className="left" htmlFor="Form_InruilenForm_Kenteken">Vul uw kenteken in</label>
              <div className="middleColumn">
                <input
                  // className={`input-licenseplate ${inputFeedback('kenteken')}`}
                  className="text kentekenField sign--half"
                  type="text"
                  name="kenteken"
                  placeholder="Kenteken"
                  id="Form_InruilenForm_Kenteken"
                  onChange={handleChangeLicense}
                  value={state.kenteken ? state.kenteken : ''}
                  maxlength="8"
                />
              </div>
            </div>
            <div className="field numeric text">
              <label className="left" htmlFor="Form_InruilenForm_Kilometerstand">Kilometerstand</label>
              <div className="middleColumn">
                <input
                  // className={`${inputFeedback('kilometerstand')}`}
                  className="numeric text"
                  type="text"
                  name="kilometerstand"
                  placeholder="Kilometerstand"
                  id="Form_InruilenForm_Kilometerstand"
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className={`feedback ${displayFeedback('kenteken')}`}>Vul Kenteken in</div>
            <div className={`feedback ${displayFeedback('kilometerstand')}`}>Vul KM stand in</div>
            <div className="clear" />
          </fieldset>
        </form>
        <div className="Actions">
          <button type="button" className='btn btn--brand' onClick={submit}>Doe de check</button>
        </div>
      </div>
    </div>
  );
}

App.propTypes = {
  api: PropTypes.string.isRequired,
  hexonkenteken: PropTypes.string,
  hexonmerk: PropTypes.string,
  hexonmodel: PropTypes.string,
  hexonuitvoering: PropTypes.string,
  hexonbrandstof: PropTypes.string,
  hexonisnieuw: PropTypes.string,
  hexonisvkv: PropTypes.string,
  hexonvoertuignummer: PropTypes.string,
  hexonklantnummer: PropTypes.string,
  hexonverkoopprijs: PropTypes.string
};

App.defaultProps = {
  hexonkenteken: undefined,
  hexonmerk: undefined,
  hexonmodel: undefined,
  hexonuitvoering: undefined,
  hexonbrandstof: undefined,
  hexonisnieuw: undefined,
  hexonisvkv: undefined,
  hexonvoertuignummer: undefined,
  hexonklantnummer: undefined,
  hexonverkoopprijs: undefined
};

export default App;
